<template>
  <v-card class="ma-0 pa-2" :style="cardClass">
    <v-card-title class="justify-end">
      <v-btn
        class="white--text"
        :class="showMobileView ? 'ma-2' : 'mr-8 mt-4'"
        :color="editable ? 'secondary' : 'primary'"
        :disabled="duplicateName"
        width="130px"
        @click="update()"
        >{{ editable ? `Done` : `Edit` }}</v-btn
      >
      <v-btn
        class="white--text"
        :class="showMobileView ? 'ma-2' : 'mr-8 mt-4'"
        color="secondary"
        width="130px"
        @click="_setAdJson(true)"
        >Edit Ad JSON</v-btn
      >
    </v-card-title>
    <div v-if="showMobileView">
      <avis-bazzbi-details-mobile v-if="_client.client_name !== 'shark'" />
      <shark-details-mobile v-if="_client.client_name === 'shark'" />
    </div>
    <div v-if="!showMobileView">
      <avis-bazzbi-details v-if="_client.client_name !== 'shark'" />
      <shark-details
        v-if="_client.client_name === 'shark'"
        v-on:setDuplicateTrue="duplicateName = true"
        v-on:setDuplicateFalse="duplicateName = false"
      />
    </div>
  </v-card>
</template>
<script>
import { mapGetters, mapMutations, mapActions } from 'vuex';
import _ from 'lodash';
import GroupDetailData from '@/mixins/GroupDetailData';
import SharkDetails from '@/components/group-details/detail-pages/SharkDetails';
import AvisBazzbiDetails from '@/components/group-details/detail-pages/AvisBazzbiDetails';
import SharkDetailsMobile from '@/components/group-details/detail-pages/SharkDetailsMobile';
import AvisBazzbiDetailsMobile from '@/components/group-details/detail-pages/AvisBazzbiDetailsMobile';
import { MobileView } from '@/mixins';

export default {
  mixins: [GroupDetailData, MobileView],
  components: {
    SharkDetails,
    AvisBazzbiDetails,
    SharkDetailsMobile,
    AvisBazzbiDetailsMobile,
  },
  data() {
    return {
      duplicateName: false,
    };
  },
  mounted() {
    this.editable = false;
    this.throttledMethod = _.debounce(() => {
      this._updateDetails();
    }, 1000);
  },
  computed: {
    ...mapGetters({
      _client: 'account/getCurrentClient',
    }),
    cardClass() {
      if (this.showMobileView) {
        return 'width: calc(100% - 32px);';
      }
      return '';
    },
  },
  methods: {
    ...mapMutations({
      _setAdJson: 'groupDetails/setAdJson',
    }),
    ...mapActions({
      _updateDetails: 'groupDetails/updateDetails',
    }),
    update() {
      if (this.editable) {
        this.throttledMethod();
      }
      this.editable = !this.editable;
    },
  },
};
</script>
